// core/infrastructure/repositories/lead/lead.repository.implementation.ts

import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LeadRepository } from '../../../domain/repositories/lead/lead.repository';
import { CreateLeadRequest, CreateLeadResponse } from '../../../domain/interfaces/lead/lead.interface';
import { LeadService } from '../../services/lead/lead.service';

@Injectable({ providedIn: 'root' })
export class LeadRepositoryImplementation extends LeadRepository {
  private readonly leadService = inject(LeadService);

  createLead(request: CreateLeadRequest): Observable<CreateLeadResponse> {
    return this.leadService.createLead(request);
  }

  // ✅ Actualizar lead existente
  updateLead(leadId: string, request: CreateLeadRequest): Observable<CreateLeadResponse> {
    return this.leadService.updateLead(leadId, request);
  }
}